import {
  RecapColorBy,
  SwingDecision,
  ZoneMetricFamily,
} from 'enums/session-recap/enums';

export const MAP_SWING_DECISION_TO_LABEL: Record<SwingDecision, string> = {
  [SwingDecision.Swing]: 'hitters.swing',
  [SwingDecision.Take]: 'hitters.recap-swing-take',
};

export const MAP_ZONE_METRIC_FAMILY_TO_LABEL: Record<ZoneMetricFamily, string> =
  {
    [ZoneMetricFamily.Pitches]: 'hitters.recap-metric-pitches',
    [ZoneMetricFamily.Swing]: 'hitters.recap-metric-swing',
    [ZoneMetricFamily.Contact]: 'hitters.recap-metric-contact',
    [ZoneMetricFamily.BattedBall]: 'hitters.recap-metric-batted-ball',
    [ZoneMetricFamily.Quality]: 'hitters.recap-metric-quality',
    [ZoneMetricFamily.Trajectory]: 'hitters.recap-metric-trajectory',
    [ZoneMetricFamily.Production]: 'hitters.recap-metric-production',
  };

export const MAP_COLOR_BY_TO_LABEL: Record<RecapColorBy, string> = {
  [RecapColorBy.Result]: 'common.result',
  [RecapColorBy.PitchType]: 'common.pitch-type',
  [RecapColorBy.Contact]: 'hitters.recap-color-by-contact',
  [RecapColorBy.ExitVelo]: 'hitters.recap-color-by-exit-velo',
  [RecapColorBy.LaunchAngle]: 'common.launch-angle',
};
